import src from "IMAGE";
export default { src, width: 500, height: 77, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AIyMjIGUlJSLj4+PhIuLi4GSkpKJl5eXjouLi4J7e3tyIr0RWLcookgAAAAASUVORK5CYII="};
